module.exports = __webpack_public_path__ + "img/shiba-body-level1.f84a0dd0.png";